import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
import Image from "../../../../../../../components/ZUILib/Image";

class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  selectedProduct = this.props.selectedProduct;

  render() {
    const { isWap, lables } = this.props;

    const _imgsrcTracker = [
      {
        srcSet: this.selectedProduct.imageURL,
      },
    ];
    const isGiftCertificate = this.props.selectedProduct.categoryName === "Gift Certificate" || this.props.selectedProduct.categoryName === "Certificado Electrónico";
    const imageAttrTracker = {
      id: "product-image",
      src: this.selectedProduct.imageURL,
      className: "product-image",
      width: isWap ? 112 : 140,
      height: isWap ? isGiftCertificate ? 90 : 147 : isGiftCertificate ? 90 : 183,
      altImg: this.selectedProduct?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };

    const amount = this.selectedProduct.price;
    const [price, cents] = amount?.split(".") ?? ["", ""];

    return (
      <div className="product-card">
        <div className="product-content">
          <Image imageAttr={imageAttrTracker} _imgsrc={_imgsrcTracker} />
          <div className="product-info">
            <div className="product-details">
              <div className="product-name">
                {this.selectedProduct.displayName}
              </div>

              <div className="product-meta">
                <span className="meta-label">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.sku.by.label"
                  )}
                  :{" "}
                </span>
                <span className="meta-value">{this.selectedProduct.skuId}</span>
              </div>

              <div className="product-meta">
                <span className="meta-label">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.qty.label"
                  )}
                  :
                </span>
                <span className="meta-value">
                  {this.selectedProduct.quantity}
                </span>
              </div>
            </div>

            <div className="product-price" data-tipe="Final price">
              <span className="price-symbol">$&nbsp;</span>
              <span className="price-main">{price}</span>
              <span className="price-decimal">{cents}</span>
            </div>

            {
              <div className="product-bono" data-bono="True">
                <span className="bono-text">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.bonus.label"
                  )}
                </span>
                {this.selectedProduct.bonusInfo === "true" ? (
                  <div className="bono-icon" data-style="Outlined">
                    <img
                      src={commonUtil.getAssetURL() + "/images/done.svg"}
                      alt="file download"
                    />
                  </div>
                ) : (
                  <div className="bono-text">
                    <span>X</span>
                  </div>
                )}
                {/* {this.selectedProduct.bonusInfo === "false" ? (
                  <div>{this.selectedProduct.bonusMessage}</div>
                ) : null} */}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ProductCard;
